import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import CameraCapture from './CameraCapture';
import './ImageUploader.css';

function ImageUploader({ label, required, preview, onImageChange, description }) {
  const [showCamera, setShowCamera] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      onImageChange(acceptedFiles[0]);
    }
  }, [onImageChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp']
    },
    multiple: false,
    maxSize: 10 * 1024 * 1024 // 10MB
  });

  const handleRemove = (e) => {
    e.stopPropagation();
    onImageChange(null);
  };

  const handleCameraCapture = (file) => {
    console.log('[ImageUploader] Camera captured file:', file?.name, file?.size, file?.type);
    if (file && file.size > 0) {
      onImageChange(file);
    } else {
      console.error('[ImageUploader] Invalid file from camera!');
    }
    setShowCamera(false);
  };

  const openCamera = (e) => {
    e.stopPropagation(); // Prevent dropzone click
    setShowCamera(true);
  };

  return (
    <div className="image-uploader">
      {showCamera && (
        <CameraCapture 
          onCapture={handleCameraCapture} 
          onCancel={() => setShowCamera(false)} 
        />
      )}

      <label className="uploader-label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      
      <div 
        {...getRootProps()} 
        className={`dropzone ${isDragActive ? 'active' : ''} ${preview ? 'has-preview' : ''}`}
      >
        <input {...getInputProps()} />
        
        {preview ? (
          <div className="preview-container">
            <img src={preview} alt={label} className="preview-image" />
            <button type="button" className="remove-button" onClick={handleRemove}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        ) : (
          <div className="upload-placeholder">
            <div className="icon-group">
              <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="file-icon">
                <rect x="4" y="8" width="40" height="32" rx="4" stroke="currentColor" strokeWidth="2"/>
                <circle cx="16" cy="20" r="4" stroke="currentColor" strokeWidth="2"/>
                <path d="M4 32L16 24L24 30L36 20L44 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            
            <p className="upload-text">
              {isDragActive ? 'Drop image here' : 'Drag & drop image'}
            </p>
            
            <div className="divider">
              <span>OR</span>
            </div>

            <button type="button" className="camera-button" onClick={openCamera}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
              Use Camera
            </button>

            <p className="upload-hint">{description}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ImageUploader;
